import { makeAutoObservable } from "mobx";
import { ParameterScope } from "../ParameterScope";
export class ModifierInstanceEditability {
    constructor(params) {
        this.scope = ParameterScope.Uninitialized;
        this.editabilityParametrization = params.editabilityParametrization;
        makeAutoObservable(this);
    }
    setScope(scope) {
        this.scope = scope;
    }
    get isEditable() {
        return this.editabilityParametrization.unify(this.scope.parameterSet);
    }
    get isPossiblyEditable() {
        return this.isEditable.isValuePossible(true);
    }
    clone() {
        return new ModifierInstanceEditability({
            editabilityParametrization: this.editabilityParametrization,
        });
    }
}
